// @flow
import {isMaxUser} from "../utils";
import {getDataInLocalStorage} from "../../_common/localStorage";

import type { DisplayPricesOption } from "./productPricingTypes";

export const hasCustomerPricePermission = (win: WindowProxy) => !!win.document.querySelector("[data-show-customer-price='true']");

export const priceViewKey = `user-price-view-preference`;

const dispatchClickToOption = (win: WindowProxy, value: string, target: string) => {
  if (value.toString() && win.document.querySelector(`[data-show-${target}=${value}]`)) {
    win.document.querySelector(`[data-show-${target}=${value}]`).parentElement.click();
  }
};

export const restoreDataFromBrowser = (win: WindowProxy): {
  showGstInclusivePreference: boolean | void,
  displayPricesOptionPreference: DisplayPricesOption | void
} => {
  let showGstInclusivePreference: boolean | void = undefined;
  let displayPricesOptionPreference: DisplayPricesOption | void = undefined;
  if (isMaxUser(win)) {
    const storedPreferences = JSON.parse(getDataInLocalStorage(priceViewKey));
    if (storedPreferences) {
      const { showGstInclusive, displayPricesOption } = storedPreferences;
      dispatchClickToOption(win, showGstInclusive, `gst-option`);
      dispatchClickToOption(win, displayPricesOption, `price-option`);
      [showGstInclusivePreference, displayPricesOptionPreference]=[showGstInclusive,displayPricesOption];
    }
  }
  return {showGstInclusivePreference, displayPricesOptionPreference}
};

export const getSelectedDisplayValues = (win: WindowProxy) => ({
    showGstInclusive:
      isMaxUser(win)
      ? win.document.querySelector(".selected[data-show-gst-option]").dataset.showGstOption  === 'true'
      : true,
  
    displayPricesOption:
      hasCustomerPricePermission(win)
      ? win.document.querySelector(".selected[data-show-price-option]").dataset.showPriceOption
      :'cmp',
});

export const checkDefaultPriceOptionPermission = (win: WindowProxy, displayPricesOptionPreference: DisplayPricesOption | void) => {
  if(hasCustomerPricePermission(win)){
    if (displayPricesOptionPreference) {
      return displayPricesOptionPreference;
    } else {
      return 'myprice_and_cmp';
    }
  }
    return 'cmp';
};

export const extractProductTilesToFetchPrices = (win: WindowProxy) =>
  [...win.document.querySelectorAll(".product-tile[data-product-code]")];



// WEBPACK FOOTER //
// ./javascript/product-search-page/product-pricing/priceUtils.js